const showLocation = () => {};

export default showLocation;
